import api from '../services/api';
import { IScheduleStatus } from '../shared/interfaces';

interface IResponseGetSchedulesStatus {
  data: IScheduleStatus[];
  count: number;
}
export const getSchedulesStatus = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetSchedulesStatus> => {
  const response = await api.post('/schedules-status/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postScheduleStatus = async (
  payload: any,
): Promise<IScheduleStatus> => {
  const response = await api.post(`/schedules-status`, payload);
  return response.data;
};

export const patchScheduleStatus = async (
  id: string | undefined,
  payload: any,
): Promise<IScheduleStatus> => {
  if (!id) {
    throw new Error('ID do Status não fornecido.');
  }
  const response = await api.patch(`/schedules-status/${id}`, payload);
  return response.data;
};

export const getSelectScheduleStatus = async (): Promise<IScheduleStatus[]> => {
  const response = await api.get(`/schedules-status/select/all`);
  return response.data;
};
